module["exports"] = [
  "Kitaplar",
  "Filmler",
  "Müzikler",
  "Oyunlar",
  "Elektronik",
  "Bilgisayarlar",
  "Ev",
  "Bahçe",
  "Aletler",
  "Bakkal",
  "Sağlık",
  "Güzellik",
  "Oyuncaklar",
  "Çocuklar",
  "Bebek",
  "Giyim",
  "Ayakkabı",
  "Mücevher",
  "Spor Dalları",
  "Açık Hava",
  "Otomotiv",
  "Sanayi"
];
